import { render, staticRenderFns } from "./EscolaBiblica.vue?vue&type=template&id=7cc0762a"
import script from "./EscolaBiblica.vue?vue&type=script&lang=js"
export * from "./EscolaBiblica.vue?vue&type=script&lang=js"
import style0 from "./EscolaBiblica.vue?vue&type=style&index=0&id=7cc0762a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports